/* eslint-disable prettier/prettier */
import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const addNotificationSuccess = () => {
  notification.success({
    message: 'User Added Successfully!',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Job Publisher has been Deleted',
  });
};

const resetAdminPasswordSuccess = (password = '') => {
  notification.success({
    message: `Admin password reset to - ${password}`,
  });
};

const deleteNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const updateNotificationSuccess = () => {
  notification.success({
    message: 'Your Record has been updated',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const {
  AddBegin,
  AddSuccess,
  AddErr,

  ReadBegin,
  ReadSuccess,
  ReadErr,

  UpdateBegin,
  UpdateSuccess,
  UpdateErr,

  DeleteBegin,
  DeleteSuccess,
  DeleteErr,

  SingleDataBegin,
  SingleDataSuccess,
  SingleDataErr,

  UploadBegin,
  UploadSuccess,
  UploadErr,
} = actions;

const DataSubmit = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddBegin());
      const response = await DataService.post('/auth/create-user', data);
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(AddSuccess(response.data.data));
        addNotificationSuccess();
        callback(true);
      } else {
        await dispatch(AddErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(AddErr('User Already Exists!'));
      addNotificationError('User Already Exists!');
    }
  };
};

const DataRead = (roleId = 2) => {
  return async (dispatch) => {
    try {
      await dispatch(ReadBegin());
      const query = await DataService.gql(QUERY.allUser(roleId));
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(ReadSuccess(query.data.data.allUserProfiles.nodes));
      } else {
        await dispatch(AddErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(ReadErr(err));
    }
  };
};

const DataSearch = (searchItem) => {
  return async (dispatch) => {
    try {
      await dispatch(ReadBegin());
      if (searchItem !== '') {
        const query = await DataService.get(`/data/search/${searchItem}`);
        await dispatch(ReadSuccess(query.data.data));
      } else {
        try {
          const query = await DataService.get('/data/all');
          await dispatch(ReadSuccess(query.data.data));
        } catch (err) {
          await dispatch(ReadErr(err));
        }
      }
    } catch (err) {
      await dispatch(ReadErr(err));
    }
  };
};

const DataUpdate = (id, data) => {
  return async (dispatch) => {
    try {
      await dispatch(UpdateBegin());
      await DataService.post(`/data/${id}/update`, data);
      await dispatch(UpdateSuccess());
      updateNotificationSuccess();
    } catch (err) {
      await dispatch(UpdateErr(err));
      updateNotificationError(err);
    }
  };
};

const DataDelete = ({ id, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteBegin());
      const data = await DataService.gql(QUERY.deleteUser({ id, isActive: false }));
      await dispatch(DeleteSuccess(data.data));
      await getData();
      deleteNotificationSuccess();
    } catch (err) {
      await dispatch(DeleteErr(err));
      deleteNotificationError(err);
    }
  };
};

const DataResetPassword = ({ id, newPassword, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteBegin());
      const data = await DataService.post('auth/rest-admin-password', { new_password: newPassword, id });
      await dispatch(DeleteSuccess(data.data));
      await getData();
      resetAdminPasswordSuccess(newPassword);
    } catch (err) {
      await dispatch(DeleteErr(err));
      deleteNotificationError(err);
    }
  };
};

const DataSingle = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(SingleDataBegin());
      const query = await DataService.get(`/data/${id}/show`);
      await dispatch(SingleDataSuccess(query.data.data[0]));
    } catch (err) {
      await dispatch(SingleDataErr(err));
    }
  };
};

const FileUploder = (imageAsFile) => {
  const data = new FormData();
  data.append('image', imageAsFile);

  return async (dispatch) => {
    try {
      await dispatch(UploadBegin());
      const query = await DataService.post('/data/image/upload', data, { 'Content-Type': 'multipart/form-data' });

      dispatch(UploadSuccess(`${query.data}`));
    } catch (err) {
      await dispatch(UploadErr(err));
    }
  };
};

const FileClear = () => {
  return async (dispatch) => {
    try {
      await dispatch(UploadBegin());
      dispatch(UploadSuccess(null));
    } catch (err) {
      await dispatch(UploadErr(err));
    }
  };
};

export { DataRead, DataSearch, DataSubmit, FileUploder, DataDelete, DataSingle, DataUpdate, FileClear, DataResetPassword };
